/** Shopify Help の管理画面言語一覧（地域別の行は同じ表示言語へ束ねる）。 */
export const ADMIN_LOCALES = [
  ["ar", "العربية"],
  ["bg", "Български"],
  ["zh-CN", "简体中文"],
  ["zh-TW", "繁體中文"],
  ["hr", "Hrvatski"],
  ["cs", "Čeština"],
  ["da", "Dansk"],
  ["nl", "Nederlands"],
  ["en", "English"],
  ["fi", "Suomi"],
  ["fr", "Français"],
  ["de", "Deutsch"],
  ["el", "Ελληνικά"],
  ["he", "עברית"],
  ["hi", "हिन्दी"],
  ["hu", "Magyar"],
  ["id", "Bahasa Indonesia"],
  ["it", "Italiano"],
  ["ja", "日本語"],
  ["ko", "한국어"],
  ["lt", "Lietuvių"],
  ["ms", "Bahasa Melayu"],
  ["nb", "Norsk bokmål"],
  ["pl", "Polski"],
  ["pt-BR", "Português (Brasil)"],
  ["pt-PT", "Português (Portugal)"],
  ["ro", "Română"],
  ["ru", "Русский"],
  ["sk", "Slovenčina"],
  ["sl", "Slovenščina"],
  ["es", "Español"],
  ["sv", "Svenska"],
  ["th", "ไทย"],
  ["tr", "Türkçe"],
  ["ur", "اردو"],
  ["vi", "Tiếng Việt"],
] as const;

export type AdminLocale = (typeof ADMIN_LOCALES)[number][0];
const LOCALE_CODES = new Set<string>(ADMIN_LOCALES.map(([code]) => code));

export function isAdminLocale(value: string): value is AdminLocale {
  return LOCALE_CODES.has(value);
}

export function normalizeAdminLocale(value: string): AdminLocale {
  const normalized = value.trim().replaceAll("_", "-").toLowerCase();
  if (!normalized) return "en";
  if (normalized.startsWith("zh-")) {
    return /^(zh-(tw|hk|mo|hant))(?:-|$)/.test(normalized) ? "zh-TW" : "zh-CN";
  }
  if (normalized === "zh") return "zh-CN";
  if (normalized.startsWith("pt-")) {
    return normalized.startsWith("pt-pt") ? "pt-PT" : "pt-BR";
  }
  if (normalized === "pt") return "pt-BR";
  const language = normalized.split("-")[0];
  if (language === "no") return "nb";
  return isAdminLocale(language) ? language : "en";
}
